<template>
    <b-container fluid class="custom-footer">
        <b-row>
            <b-col>
                <div class="title">{{customerService.title}}</div>
                <b-nav vertical class="w-30">
                    <b-nav-item v-for="(nav, index) in customerService.items" :key="index" @click="goToPage(nav.link_href)">
                        <a :href="nav.link_href" onclick="return false">
                            {{nav.text}}
                        </a>
                    </b-nav-item>
                </b-nav>
            </b-col>
            <b-col>
                <div class="title">{{legalProvision.title}}</div>
                <b-nav vertical class="w-30">
                    <b-nav-item v-for="(nav, index) in legalProvision.items" :key="index" @click="goToPage(nav.link_href)">
                        <a :href="nav.link_href" onclick="return false">
                            {{nav.text}}
                        </a>
                    </b-nav-item>
                </b-nav>
            </b-col>
            <b-col>
                <div class="title">{{socialContact.title}}</div>
                <b-nav class="w-30 social-contact">
                    <b-nav-item v-for="(nav, index) in socialContact.items" :href="nav.pop_image || nav.link_href" target="_blank" :key="index">
                        <img :src="nav.icon" :alt="nav.text">
                    </b-nav-item>
                </b-nav>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="3">
                <div class="logo-footer">
                    <span>{{logoFooter.text}}</span>
                    <img :src="logoFooter.logo" alt="">
                </div>
            </b-col>
            <b-col>
                <div class="company-info">
                    {{companyInfo.copyright}}
                    {{companyInfo.address}}
                    {{companyInfo.telephone}}
                    <a :href="companyInfo.icpHref" target="_blank">{{companyInfo.icpText}}</a>
                    {{companyInfo.otherText}}
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    export default {
        name: 'customFooter',
        props: {
            customerService: {
                type: Object
            },
            legalProvision: {
                type: Object
            },
            socialContact: {
                type: Object
            },
            logoFooter: {
                type: Object
            },
            companyInfo: {
                type: Object
            }
        },
        methods: {
            goToPage(path) {
                this.$router.push({
                    path: path
                })
                document.scrollingElement.scrollTop = 0
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/style/var";

    @font-size: 14px;
    @title-font-size: @font-size;
    @nav-font-size: @font-size;
    @img-width: 27px;

    .en {
        .custom-footer {
            .title {
                font-family: Montserrat-SemiBold, Helvetica, Arial, sans-serif !important;
            }
        }

        .nav-item {
            font-size: 12px !important;
        }
    }

    .title {
        margin-bottom: 13px;
        color: @primary-dark-color;
        font-family: NotoSansKR-Bold, Helvetica, Arial, sans-serif;
        text-align: left;
        font-size: @title-font-size;
    }

    .social-contact {
        .nav-item {
            &:nth-child(n+2) {
                margin-left: 19px;
            }
        }
    }

    .nav-item {
        text-align: left;
        font-size: 13px;

        a {
            img {
                width: @img-width;
                transition: transform .3s;

                &:hover {
                    transform: scale(1.1);
                }
            }
        }

        .nav-link {
            transition: color .3s;
            padding: 7px 0;
            color: @primary-dark-color;

            &:hover {
                color: #666;
            }
        }
    }

    .logo-footer {
        margin-top: @page-padding;
        text-align: left;
        font-family: NotoSansKR-Bold, Helvetica, Arial, sans-serif;
        font-size: 21px;
        line-height: 24px;
        display: flex;
        align-items: center;

        img {
            display: block;
            width: 150px;
            margin-left: 12px;
            vertical-align: middle;
        }
    }

    .company-info {
        margin-top: @page-padding;
        font-size: 10px;
        color: @primary-dark-color;
        line-height: 24px;

        a {
            color: @primary-dark-color;
            cursor:pointer;
            transition: font-weight .3s;
            &:hover {
                font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
            }
        }
    }
</style>
